import axios from 'axios'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import swal from "sweetalert";

export const useZeroPayment = (payload) => {

    const [freeRegBuffer, setFreeRegBuffer] = useState(false);
    const history = useHistory();

    const freeRegistration = () => {
        setFreeRegBuffer(true);
        axios.get("/sanctum/csrf-cookie").then((response) => {
            axios.post(`/api/user/event-register`, payload).then((res) => {

                setFreeRegBuffer(false);
                swal("Success", 'Registration Done', "success");
                history.push("/");

            }).catch((err) => {
                console.log(err.message)
            });
        });
    };

    return { freeRegistration, freeRegBuffer }

}

